import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  alldrivers: [],
  loading: false,
  error: null,
};

const driverSlice = createSlice({
  name: "alldrivers",
  initialState,
  reducers: {
    setDrivers: (state, action) => {
      state.alldrivers = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { setDrivers, setLoading, setError } = driverSlice.actions;

export const fetchDrivers = () => async (dispatch) => {
  dispatch(setLoading());
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/driver/alldriver`);
    dispatch(setDrivers(response.data));
  } catch (error) {
    dispatch(setError(error.message));
  }
};

export default driverSlice.reducer;
